import { gql } from 'apollo-angular';

export const ScreenElementFragment = gql`
  fragment ScreenElement on ScreenElementOutput {
    id
    name
    seatIds
  }
`;
